import { Injectable, inject } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

interface ErrorResponse {
  Success?: boolean;
  ErrorMessage?: string;
  ExceptionType?: string;
  StackTrace?: string;
  InnerException?: any;
  Source?: string;
  Context?: string;
  Timestamp?: string;
}

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private spinner = inject(NgxSpinnerService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 || this.isForbiddenAccessException(error)) {
          this.spinner.hide();
          if (!this.isPublicHomepage()) {
            this.router.navigate(["/forbidden"]);
          }
          return throwError(() => error);
        }

        // Check if the error response body contains UnauthorizedAccessException
        if (error.status === 401 || this.isUnauthorizedAccessException(error)) {
          // Hide loading spinner before redirecting
          this.spinner.hide();
          // Redirect to unauthorized page
          this.router.navigate(["/unauthorized"]);
          return throwError(() => error);
        }

        // Let other errors pass through
        return throwError(() => error);
      })
    );
  }

  private isUnauthorizedAccessException(error: HttpErrorResponse): boolean {
    if (!error.error) {
      return false;
    }

    const errorResponse = error.error as ErrorResponse;
    return (
      errorResponse.ExceptionType === "System.UnauthorizedAccessException"
    );
  }

  private isForbiddenAccessException(error: HttpErrorResponse): boolean {
    if (!error.error) {
      return false;
    }

    const errorResponse = error.error as ErrorResponse;
    return errorResponse.ExceptionType === "PosApi.Tools.ForbiddenAccessException";
  }

  private isPublicHomepage(): boolean {
    const currentPath = this.router.url.split("?")[0].split("#")[0];
    return currentPath === "/" || currentPath === "/dashboard";
  }
}
